<template>
  <div class="">
    <div class="flex items-center">
      <RequiredAsterisk v-if="required"></RequiredAsterisk>
      <div class="label-standard">{{ label }}</div>
      
      <div v-if="tooltip != null" class="float-left ml-4" style="margin-top:1px;">
        <div class="" v-tooltip.top="{ html: objectId + propertyKey + 'Tooltip' }">
          <img src="/static/img/icons/icons8-info-grey.png" style="width:13px;height:13px;" />
        </div>

        <div :id="objectId + propertyKey + 'Tooltip'" class="p-1">{{ tooltip }}</div>
      </div>
    </div>

    <div :class="{ relative : true, 'form-line' : label != null }">

      <input type="text"
        class="input-standard"
        ref="value"
        v-bind:value="localValue"
        v-on:keyup="inputTextTyped"
        v-on:blur="updateValue({
          index     : index,
          objectType: objectType,
          objectId  : objectId,
          key       : propertyKey, 
          value     : $event.target.value
        })" />
    </div>

    <div v-if="subLabel != null" class="mt-2 text-sm text-gray-700">{{ subLabel }}</div>
  </div>
</template>

<script>

  import commaNumber      from 'comma-number'
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    components : {
      RequiredAsterisk
    },

    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type : Number,
        required : false
      },

      label : {
        type    : String,
        required: false
      },

      subLabel : {
        type    : String,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      // Object name is required if data array consist of two different data model e.g "broker" & "user" and we use object name to specfiy for which model we are updating the data in this component.
      objectName : {
        type    : String,
        required: false
      },

      value : {
        // type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      index : {
        type    : Number,
        required: false,
      },

      focusWhen : {
        type : Boolean, 
        required : false
      },

      required : {
        type    : Boolean,
        required: false,
        default : false
      }
    },

    computed : {
      localValue() {
        return this.value != null ? commaNumber(this.value) : null
      }
    },

    watch : {
      focusWhen : function(prev, curr) {
        if(this.focusWhen) {

          this.$refs.value.focus()
        }
      }
    },

    methods : {

      // for some components, we are updating something that is repeated via v-for.
      // For example, addresses. An applicant has multiple addresses, so we do
      // <v-for address in addresses>
      //   <InputText address>
      // But when we are doing the autosave, we actually need to know which address we are
      // updating. We can do this via index, which is passed as a prop.
      // For some, it's not repeated, so we don't need the index. So, instead of going
      // directly to updateValue, we are going via "localUpdateValue, so that we can check
      // if index exists, or not
      localUpdateValue(key, value) {
        if(this.index != null) {
          this.updateValue(this.objectType, this.index, key, value);
        }

        else if(this.objectName != null) {
          this.updateValue(this.objectName, key, value);
        } 

        else {
          this.updateValue(key, value);
        }
      },

      inputTextTyped($elem) {
        let val = ($elem.target.value).replace(/[^0-9\.]/g, '').replace(/^0([^\.])/g, '$1');

        // if (type == 'dollar_integer') {
        //   val = val.replace('.','');
        // } else {
          //Replace all but the last period
          if (val.indexOf('.') != -1) {
            var temp = val.split('.')
            var last = temp.pop()

            //Make sure that the last period has two numbers after it
            while (last.length > 2) {
              last = last.substr(last.length-2, 2);
            }

            val = temp.join('')+'.'+last;
          }
        // }

        //Comma format the number
        val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        this.$refs.value.value = val
      },
    }
  }
</script>